import { cloneDeep, omit } from 'lodash';

const TABLE_QUERY_STORAGE_KEY = 'table-query';
const LEGACY_QUERY_KEYS = [
  'searchBy',
  'tags',
  'marks',
  'text',
  'tagsLogicalRelation',
  'textLogicalRelation',
];

export const createInitialTableQuery = () => {
  const fromStorage = omit(
    JSON.parse(window.localStorage.getItem(TABLE_QUERY_STORAGE_KEY) || '{}'),
    LEGACY_QUERY_KEYS,
  );

  return {
    ...cloneDeep(fromStorage),
    search: {},
    offset: {},
  };
};
